<template>
    <div class="detail-process card h-auto card-filled">
        <div class="card__text h-100 justify-content-center px-2 py-2">
            <ul class="detail-process__info list-unstyled">
                <li class="mb-2">
                    <span class="mr-3 font-weight-bold">Article:</span>
                    {{ process.article }}
                </li>
                <li class="mb-2">
                    <span class="mr-3 font-weight-bold">Type:</span>
                    {{ process.type }}
                </li>
                <li class="mb-2">
                    <span class="mr-3 font-weight-bold">Applicable:</span>
                    {{ process.applicable }}
                </li>
                <li class="mb-2">
                    <span class="mr-3 font-weight-bold">Name:</span>
                    {{ process.name }}
                </li>
                <li class="mb-2">
                    <span class="mr-3 font-weight-bold">Agency:</span>
                    {{ process.agency }}
                </li>
                <li class="mb-2">
                    <span class="mr-3 font-weight-bold">Legal act:</span>
                    {{ process.legalAct }}
                </li>
            </ul>

            <div class="mb-4">
                <span class="mr-3 font-weight-bold d-block">Content:</span>
                {{ process.content }}
            </div>

            <div class="d-lg-flex justify-content-between detail-step__wrapper">
                <detail-steps
                    v-for="(step, index) in process.steps"
                    :key="index"
                    :step="step"
                ></detail-steps>
            </div>
        </div>
    </div>
</template>

<script>
import detailSteps from '@/components/legislationMonitor/legislation-detail/detail-steps';

export default {
    components: {
        detailSteps
    },

    props: {
        process: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {};
    }
};
</script>

<style lang="scss">
.detail-step__wrapper {
    position: relative;

    @include media-breakpoint-up(lg) {
        &:after {
            content: '';
            position: absolute;
            width: calc(100% - 100px);
            height: 2px;
            background-color: $brand-blue;
            top: 57px;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            left: 50px;
        }
    }
}

.detail-process__info {
    @include media-breakpoint-up(lg) {
        column-count: 2;
    }
}

.detail-process__info li {
    @include media-breakpoint-up(lg) {
        break-inside: avoid;
        -webkit-column-break-inside: avoid;
        page-break-inside: avoid;
        break-inside: avoid;
    }
}

.detail-process__info li span {
    display: block;
}

.detail-step {
    flex: 0 1 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 4rem;

    @include media-breakpoint-up(lg) {
        margin-bottom: 0;
    }
}

.detail-step__name {
    border: 2px solid $brand-blue;
    background-color: $brand-white;
    width: 200px;
    height: 200px;
    border-radius: 90%;
    position: relative;
    text-align: center;
    z-index: 20;

    @include media-breakpoint-up(lg) {
        width: 114px;
        height: 114px;
    }
}

.detail-step__name span {
    position: absolute;
    left: 50%;
    font-size: 1.25rem;
    line-height: 1.4;
    top: 50%;
    transform: translate(-50%, -50%);

    @include media-breakpoint-up(lg) {
        font-size: 0.825rem;
    }
}

.detail-step__active .detail-step__name {
    background-color: $brand-blue;
    color: $white;
}
</style>
